var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{staticClass:"blue-background",attrs:{"cols":"12","md":"6"}},[_c('back-link',{attrs:{"icon":"","large":""}}),_c('join-whatsapp-block',{attrs:{"canComplete":""},on:{"complete":_vm.complete}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }